import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Alert, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Snackbar, Stack, TextField, Typography } from '@mui/material';
import { OfficeService, getAuthToken } from '../../service';

const OfficeDialog = ({ officeId, dialogOpen, onClose, onSave }) => {
    const { instance, accounts } = useMsal();
    const [isLoading, setIsLoading] = useState(true);

    const [office, setOffice] = useState();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await getOfficeData();
            setIsLoading(false);
        })();
    }, [officeId]);

    const getOfficeData = async () => {
        const authToken = await getAuthToken(instance, accounts[0]);
        const data = await OfficeService.getById(authToken, officeId);

        if (!data) {
            console.error('Error : Unable to get Office data.');
            return;
        }

        setOffice(data);
    };

    const handleCloseDialog = () => {
        onClose();
    };

    const hanldeCloseClick = () => {
        onClose();
    };

    const handleSaveClick = async () => {
        const authToken = await getAuthToken(instance, accounts[0]);
        const data = await OfficeService.save(authToken, office);

        if (!data) {
            console.error('Error : Unable to save Office data.');
            return;
        }

        onSave(true);
    };

    return (
        <>
            {isLoading ? (
                <Typography>Loading...</Typography>
            ) : (
                <Dialog style={{ zIndex: 90 }} open={dialogOpen} onClose={handleCloseDialog} scroll={'paper'} maxWidth={'100%'}>
                    <DialogTitle id="scroll-dialog-title" scroll={'paper'} style={{ backgroundColor: 'rgb(0, 42, 78)', color: 'rgb(255, 255, 255)' }}>
                        Edit Office Information
                    </DialogTitle>
                    <DialogContent dividers={true}>
                        <Stack direction={'column'} spacing={2}>
                            <Divider>
                                <Chip label="Location Details" color="primary" />
                            </Divider>
                            <TextField
                                required
                                fullWidth
                                size="small"
                                label="Office Name"
                                variant="filled"
                                inputProps={{ maxLength: 60 }}
                                value={office.Name}
                                onChange={(event) => setOffice((state) => ({ ...state, Name: event.target.value }))}
                            />

                            <Stack direction={'row'} spacing={2}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Address 1"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.AddressLine1}
                                    onChange={(event) => setOffice((state) => ({ ...state, AddressLine1: event.target.value }))}
                                />
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="Address 2 (optional)"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.AddressLine2}
                                    onChange={(event) => setOffice((state) => ({ ...state, AddressLine2: event.target.value }))}
                                />
                            </Stack>

                            <Stack direction={'row'} spacing={2}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="City"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.City}
                                    onChange={(event) => setOffice((state) => ({ ...state, City: event.target.value }))}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Country"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Country}
                                    onChange={(event) => setOffice((state) => ({ ...state, Country: event.target.value }))}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Division"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Division}
                                    onChange={(event) => setOffice((state) => ({ ...state, Division: event.target.value }))}
                                />
                            </Stack>

                            <Stack direction={'row'} spacing={2}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Latitude"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Lat}
                                    onChange={(event) => setOffice((state) => ({ ...state, Lat: event.target.value }))}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Longtitude"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Lng}
                                    onChange={(event) => setOffice((state) => ({ ...state, Lng: event.target.value }))}
                                />
                            </Stack>

                            <Divider>
                                <Chip label="Contact Information" color="primary" />
                            </Divider>

                            <Stack direction={'row'} spacing={2}>
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Email"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Email}
                                    onChange={(event) => setOffice((state) => ({ ...state, Email: event.target.value }))}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Phone"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Phone}
                                    onChange={(event) => setOffice((state) => ({ ...state, Phone: event.target.value }))}
                                />
                                <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Fax"
                                    variant="filled"
                                    inputProps={{ maxLength: 60 }}
                                    value={office.Fax}
                                    onChange={(event) => setOffice((state) => ({ ...state, Fax: event.target.value }))}
                                />
                            </Stack>

                            <Divider>
                                <Chip label="Audit Information" color="primary" />
                            </Divider>

                            <Stack direction={'row'} spacing={2}>
                                <TextField fullWidth size="small" label="Created By :" variant="filled" inputProps={{ maxLength: 40 }} value={office.CreatedBy} readOnly />
                                <TextField fullWidth size="small" label="Updated By :" variant="filled" inputProps={{ maxLength: 40 }} value={office.UpdatedBy} readOnly />
                            </Stack>
                            <Stack direction={'row'} spacing={2}>
                                <TextField fullWidth size="small" label="Created On :" variant="filled" inputProps={{ maxLength: 40 }} value={office.CreatedOn} readOnly />
                                <TextField fullWidth size="small" label="Updated On :" variant="filled" inputProps={{ maxLength: 40 }} value={office.UpdatedOn} readOnly />
                            </Stack>
                        </Stack>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'space-between' }}>
                        <Button onClick={hanldeCloseClick} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={handleSaveClick} variant="contained">
                            Save
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
};

const OfficeEdit = ({ officeId, onPostSave }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const [open, setOpen] = useState(false);

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleSaveDialog = (isSuccess) => {
        if (!isSuccess) return;

        setOpen(true);
        setDialogOpen(false);
        onPostSave();
    };

    const handleEditClick = () => {
        setDialogOpen(true);
    };

    const handleCloseSnackBar = () => {
        setOpen(false);
    };

    return (
        <>
            <Button variant="contained" size="small" onClick={handleEditClick}>
                Edit
            </Button>
            <OfficeDialog officeId={officeId} dialogOpen={dialogOpen} onClose={handleCloseDialog} onSave={handleSaveDialog} />
            <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseSnackBar}>
                <Alert variant="filled" onClose={handleCloseSnackBar} severity="success" sx={{ width: '100%' }}>
                    Updated Office Information.
                </Alert>
            </Snackbar>
        </>
    );
};

export default OfficeEdit;
